export const STRATEGY_DISPOSITION = {
  "onDispositions": function (json) {
    if (typeof onDispositions === 'function') {
      onDispositions(json.data);
    }
  },
  "onDisposeApplied": function () {
    if (typeof onDisposeApplied === 'function') {
      onDisposeApplied();
    }
  },
  "onPhoneNumbers": function (json) {
    if (typeof onPhoneNumbers === 'function') {
      onPhoneNumbers(json.data);
    }
  },
  "onReprogramCall": function (json) {
    if (typeof onReprogramCall === 'function') {
      onReprogramCall(json.data);
    }
  },
  "onReprogramSuccess": function () {
    if (typeof onReprogramSuccess === "function") {
      onReprogramSuccess();
    }
  },
  "onDispositionsAndNumbers": function (json) {
    if (typeof onDispositionsAndNumbers === 'function') {
      onDispositionsAndNumbers(json.data);
    }
  },
  "errorOnDispose": function (json) {
    if (typeof errorOnDispose === 'function') {
      errorOnDispose(json.data)
    }
  }
}


// WEBPACK FOOTER //
// ./src/Strategies/strategyDispositon.js